import { gql } from "@apollo/client";

export const GET_LAN_CONTROLLERS_BY_DOMAIN = gql`
  query LanControllers($domain: String!, $limit: Int!, $offset: Int!) {
    controller {
      lanControllers(domain: $domain, limit: $limit, offset: $offset) {
        lan_controller_id
        cpu_id
      }
    }
  }
`;

export interface LanControllersByDomainArgs {
  domain: string;
  limit: number;
  offset: number;
}

export interface DomainLanController {
  lan_controller_id: number;
  cpu_id: string;
}

export interface DomainLanControllersResponse {
  controller: {
    lanControllers: DomainLanController[];
  };
}